import { render, staticRenderFns } from "./overduePayment.vue?vue&type=template&id=32b11425"
import script from "./overduePayment.vue?vue&type=script&lang=js"
export * from "./overduePayment.vue?vue&type=script&lang=js"
import style0 from "./overduePayment.vue?vue&type=style&index=0&id=32b11425&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports